module.exports = __webpack_public_path__ + "img/jobView-selected.be84a268.svg";